import { Box, Stack, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useState } from "react";

import { useResponsive } from "@app/hooks";
import { Strings } from "@app/constants";
import { IBrandData } from "../types";
import { RowActions } from "./row-actions";
import { deleteBrand } from "../slice";
import { AddBrandModal } from "./add-brand-modal";
import { useTheme } from "@mui/material/styles";

interface Props {
  item: IBrandData;
}

export const BrandCard = ({ item }: Props) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const { id, image, name } = item;
  const isTab = useResponsive("between", "sm", "md");

  const fontFamily = Strings.fontLanguage.workSans;

  const [editBrandDialog, setEditBrandDialog] = useState<boolean>(false);

  const handleDelete = () => {
    if (id) {
      dispatch(deleteBrand({ brandId: id }));
    }
  };

  return (
    <>
      <Box
        key={id}
        sx={{
          width: isTab ? "205px" : "233px",
          alignItems: "center",
          justifyContent: "center",
          "&:hover .row-actions": {
            visibility: "visible",
          },
        }}
      >
        <Stack
          sx={{
            position:"relative",
            width: "100%",
            height: 200,
            border: 1,
            borderColor: "#ACCFF4",
            background: "linear-gradient(180deg, #F8FBFF 0%, #D3E6F8 100%)",
            borderRadius: 2,
            overflow:"hidden"
          }}
        >
          <Stack
            direction="row"
            justifyContent="flex-end"
            className="row-actions"
            sx={{
              visibility: "hidden",
              transition: "visibility 0.2s ease-in-out",
              position:"absolute",
              right:5,
              top:10,
              p:0.5,
              backgroundColor: theme.palette.common.white,
            }}
          >
            <RowActions
              handleDelete={handleDelete}
              handleEdit={() => {
                setEditBrandDialog(true);
              }}
            />
          </Stack>
          <img
            src={image ?? ""}
            alt={name}
            style={{
              width: "100%",
              height:"100%",
              objectFit: "cover",
              }}
            />
        </Stack>

        <Typography
          mt={2}
          fontWeight={700}
          variant="body1"
          fontFamily={fontFamily}
          width={"100%"}
          textAlign={"center"}
          color={theme.palette.grey[600]}
        >
          {name}
        </Typography>
      </Box>
      {editBrandDialog && (
        <AddBrandModal
          open
          onClose={() => {
            setEditBrandDialog(false);
          }}
          onSubmit={() => {}}
          selectedBrandData={item}
        />
      )}
    </>
  );
};
